<kt-map-comparable-info
  [comparables$]="comparables$"
  [selectedRefNums$]="refNums$"
  [user]="data.currentUser"
  [loading$]="loading$"
  [hasAddButton]="true"
  [hasShowInfoButton]="true"
  (noClick)="onNoClick()"
  (add)="onAddComparable($event)"
  (openInfoModal)="onOpenInfoModal($event)"></kt-map-comparable-info>